import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 46000-46999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const layoutViewErrors = {
  // 46xxx layoutView. Its "Project not found." site reused PROJECT_NOT_FOUND. Distinct from the
  // views module (38xxx): a layout view is a different resource.
  LAYOUT_VIEW_SAVE_FAILED: {
    errorCode: 46001,
    errorMessage: t("The view could not be saved."),
    isDynamic: false,
  },
  LAYOUT_VIEW_NOT_FOUND: {
    errorCode: 46002,
    errorMessage: t("View not found."),
    isDynamic: false,
  },
  // Deliberately undifferentiated: gone, not yours, or already deleted.
  LAYOUT_VIEW_DELETE_MATCHED_NOTHING: {
    errorCode: 46003,
    errorMessage: t("The view was not deleted — it no longer exists, belongs to another user, or was already deleted."),
    isDynamic: false,
  },
  LAYOUT_VIEW_UPDATE_NOT_APPLICABLE: {
    errorCode: 46004,
    errorMessage: t(
      "The view was not updated — it no longer exists, belongs to another user, or already held these values.",
    ),
    isDynamic: false,
  },
  // 46005-46007 arrived with staging's shared-layout work. The two "not applicable" entries read
  // almost like 46003/46004 above but are NOT duplicates: those two describe the ownership-scoped
  // writes, whose filter includes `createdBy`, so "belongs to another user" is one of the reasons
  // they can match nothing. These describe the PROJECT_DASHBOARD writes, which are permission-scoped
  // and deliberately leave `createdBy` out of the filter — so that clause would be a lie there.
  LAYOUT_NAME_REQUIRED: {
    errorCode: 46005,
    errorMessage: t("A layout name is required."),
    isDynamic: false,
  },
  LAYOUT_UPDATE_NOT_APPLICABLE: {
    errorCode: 46006,
    errorMessage: t("The layout was not updated — it no longer exists or already held these values."),
    isDynamic: false,
  },
  LAYOUT_DELETE_MATCHED_NOTHING: {
    errorCode: 46007,
    errorMessage: t("The layout was not deleted — it no longer exists or was already deleted."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
